import { defineComponent as _defineComponent } from 'vue'
import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FAQs',
  setup(__props) {

  const { translateString } = useI18n()

  const faqs = [
    {
      title: translateString('faqs.item1.title'),
      description: translateString('faqs.item1.description'),
    },
    {
      title: translateString('faqs.item2.title'),
      description: translateString('faqs.item2.description'),
    },
    {
      title: translateString('faqs.item3.title'),
      description: translateString('faqs.item3.description'),
    },
  ]

return { __sfc: true,translateString, faqs, useI18n }
}

})